// extracted by mini-css-extract-plugin
module.exports = {"content":"IncomeInfo_content__9L5uC","block":"IncomeInfo_block__O-J6g","blockTitle":"IncomeInfo_blockTitle__deEnl","blockValue":"IncomeInfo_blockValue__3sVEK"};